// Helpers for the Tickets → "Ekspor Excel / PDF Rekap Bulanan" dialog.
// Kept in a plain module so unit tests can inject a deterministic `today`.

/** Format Date as YYYY-MM-DD in the browser's local timezone (matches the
 *  `<input type="date">` value shape). */
export function toIsoLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

/** Default range shown when the export dialog is opened: 1st of the running
 *  month → today. */
export function computeThisMonthRange(today = new Date()) {
  const from = new Date(today.getFullYear(), today.getMonth(), 1);
  const to = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return { date_from: toIsoLocal(from), date_to: toIsoLocal(to) };
}

/** Rolling N-day window ending today (inclusive), e.g. 7d/30d presets. */
export function computeRollingDaysRange(days, today = new Date()) {
  const to = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (days - 1));
  return { date_from: toIsoLocal(from), date_to: toIsoLocal(to) };
}

/** "Semua" — clears both fields so the backend exports every row. */
export function emptyRange() {
  return { date_from: "", date_to: "" };
}
